/**
 * Quiz Results Page: Mobile-First Optimization
 * Thumb-friendly CTAs, swipeable galleries, enhanced mobile performance
 */

(function() {
  'use strict';

  /**
   * Detect mobile device
   */
  function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
           window.innerWidth < 768;
  }

  /**
   * Enhance mobile CTAs (thumb-friendly)
   */
  function enhanceMobileCTAs() {
    if (!isMobile()) return;

    const ctas = document.querySelectorAll('[data-results-add-to-cart], [data-mobile-add-to-cart], .veluna-quiz-results-optimal__cta-primary');
    ctas.forEach(cta => {
      // Ensure minimum touch target size (44x44px)
      const computedStyle = window.getComputedStyle(cta);
      const minSize = 44;
      
      if (parseInt(computedStyle.minHeight) < minSize) {
        cta.style.minHeight = `${minSize}px`;
        cta.style.minWidth = `${minSize}px`;
      }

      // Add mobile-specific class
      cta.classList.add('veluna-mobile-optimized');
    });
  }

  /**
   * Create swipeable product gallery
   */
  function initSwipeableGallery() {
    if (!isMobile()) return;

    const productImages = document.querySelectorAll('.veluna-quiz-results-optimal__product-image');
    if (productImages.length === 0) return;

    // Group images into gallery
    const galleryContainer = document.createElement('div');
    galleryContainer.className = 'veluna-quiz-results-mobile__gallery';
    galleryContainer.setAttribute('role', 'region');
    galleryContainer.setAttribute('aria-label', 'Product images gallery');

    const imageWrapper = document.createElement('div');
    imageWrapper.className = 'veluna-quiz-results-mobile__gallery-wrapper';

    productImages.forEach((img, index) => {
      const slide = document.createElement('div');
      slide.className = 'veluna-quiz-results-mobile__gallery-slide';
      if (index === 0) slide.classList.add('veluna-quiz-results-mobile__gallery-slide--active');
      slide.appendChild(img.cloneNode(true));
      imageWrapper.appendChild(slide);
    });

    // Add navigation dots
    const dots = document.createElement('div');
    dots.className = 'veluna-quiz-results-mobile__gallery-dots';
    dots.setAttribute('role', 'tablist');
    dots.setAttribute('aria-label', 'Gallery navigation');
    
    productImages.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.className = 'veluna-quiz-results-mobile__gallery-dot';
      if (index === 0) {
        dot.classList.add('veluna-quiz-results-mobile__gallery-dot--active');
        dot.setAttribute('aria-selected', 'true');
      }
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
      dot.addEventListener('click', () => goToSlide(index));
      dots.appendChild(dot);
    });

    galleryContainer.appendChild(imageWrapper);
    galleryContainer.appendChild(dots);

    // Add swipe support
    let startX = 0;
    let currentX = 0;
    let currentSlide = 0;

    function goToSlide(index) {
      currentSlide = index;
      const slides = imageWrapper.querySelectorAll('.veluna-quiz-results-mobile__gallery-slide');
      const dotButtons = dots.querySelectorAll('.veluna-quiz-results-mobile__gallery-dot');
      
      slides.forEach((slide, i) => {
        slide.classList.toggle('veluna-quiz-results-mobile__gallery-slide--active', i === index);
      });
      
      dotButtons.forEach((dot, i) => {
        dot.classList.toggle('veluna-quiz-results-mobile__gallery-dot--active', i === index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });

      imageWrapper.style.transform = `translateX(-${index * 100}%)`;
    }

    imageWrapper.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    });

    imageWrapper.addEventListener('touchmove', (e) => {
      currentX = e.touches[0].clientX;
    });

    imageWrapper.addEventListener('touchend', () => {
      const diff = startX - currentX;
      const threshold = 50;

      if (Math.abs(diff) > threshold) {
        if (diff > 0 && currentSlide < productImages.length - 1) {
          goToSlide(currentSlide + 1);
        } else if (diff < 0 && currentSlide > 0) {
          goToSlide(currentSlide - 1);
        }
      }
    });

    // Insert gallery (replace original images on mobile)
    const firstImage = productImages[0];
    if (firstImage && firstImage.parentElement) {
      firstImage.parentElement.insertBefore(galleryContainer, firstImage);
      // Hide original images on mobile
      productImages.forEach(img => {
        img.style.display = 'none';
      });
    }
  }

  /**
   * Enhance sticky mobile CTA bar
   */
  function enhanceMobileCTA() {
    if (!isMobile()) return;

    const mobileCTA = document.querySelector('[data-jarvis-element="quiz-results-mobile-cta"]');
    if (!mobileCTA) return;

    // Make it more prominent
    mobileCTA.style.position = 'fixed';
    mobileCTA.style.bottom = '0';
    mobileCTA.style.left = '0';
    mobileCTA.style.right = '0';
    mobileCTA.style.zIndex = '1000';
    mobileCTA.style.boxShadow = '0 -4px 20px rgba(0, 0, 0, 0.15)';

    // Show immediately on mobile
    mobileCTA.style.display = 'block';
  }

  /**
   * Optimize mobile performance
   */
  function optimizeMobilePerformance() {
    if (!isMobile()) return;

    // Reduce animations on mobile
    const style = document.createElement('style');
    style.textContent = `
      @media (max-width: 768px) {
        * {
          animation-duration: 0.3s !important;
          transition-duration: 0.2s !important;
        }
      }
    `;
    document.head.appendChild(style);

    // Defer non-critical images
    const nonCriticalImages = document.querySelectorAll('img:not([data-critical])');
    nonCriticalImages.forEach(img => {
      if (!img.hasAttribute('loading')) {
        img.setAttribute('loading', 'lazy');
      }
    });
  }

  /**
   * Initialize mobile optimizations
   */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    function waitForContent() {
      const resultsContainer = document.querySelector('[data-quiz-results-optimal]');
      if (resultsContainer && resultsContainer.innerHTML.trim()) {
        enhanceMobileCTAs();
        initSwipeableGallery();
        enhanceMobileCTA();
        optimizeMobilePerformance();
        console.log('Quiz Results Mobile: Optimizations initialized');
      } else {
        setTimeout(waitForContent, 100);
      }
    }

    waitForContent();
  }

  init();

  // Export
  if (typeof window !== 'undefined') {
    window.VelunaQuizResultsMobile = {
      isMobile,
      enhanceMobileCTAs,
      initSwipeableGallery,
      enhanceMobileCTA
    };
  }
})();









